module.exports = __webpack_public_path__ + "img/76f22051ebf9eaa9333cd7a20bd9c285.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/images/operational_bulletin.jpg
 ** module id = 422
 ** module chunks = 0
 **/